import { Menu, Text } from '@mantine/core'
import { openConfirmModal } from '@mantine/modals'
import type { Resource } from '@medplum/fhirtypes'
import { IconTrash } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useFhirDeleteMutation } from '#src/hooks/useFhirDeleteMutation.ts'
import { toast } from '#src/utils/toast.ts'

interface ReactTableDeleteActionProps<T extends Resource> {
  row: T
}

export function ReactTableDeleteAction<T extends Resource>({
  row,
}: ReactTableDeleteActionProps<T>): JSX.Element {
  const deleteMutation = useFhirDeleteMutation(row.resourceType, {
    mutation: {
      onSuccess: () => {
        toast.success(`${row.resourceType} has been successfully deleted.`)
      },
    },
  })

  const handleDelete = (): void => {
    deleteMutation.mutate(row)
  }

  const handleOpenModal = (event: React.MouseEvent): void => {
    event.preventDefault()
    event.stopPropagation()
    openConfirmModal({
      title: 'Confirm Deletion',
      children: <Text>Are you sure you want to delete this resource?</Text>,
      labels: { confirm: 'Delete', cancel: 'Cancel' },
      confirmProps: { color: 'red', loading: deleteMutation.isPending },
      onConfirm: handleDelete,
    })
  }

  return (
    <Menu.Item
      color="red"
      leftSection={<IconTrash />}
      onClick={handleOpenModal}
    >
      Delete
    </Menu.Item>
  )
}
